export default __webpack_public_path__ + "static/media/visa.28f8f362.svg";